import { Point2d } from '../../point2d.model';
import { ReferenceType } from '../../reference-type.enum';
import { Loads } from '../loads.model';
import { BoundaryCondition } from './boundary-condition.enum';
import { NodeType } from './node-type.enum';
import { PrescribedMovementAssembly } from './prescribed-movement-assembly.model';

export class Node {
  id: number;
  type: NodeType;
  title: string;
  internalId: number;
  referenceId: number;
  boundaryCondition: BoundaryCondition[];
  spring: number[];
  springNonLinearId: Point2d[];
  assemblyReferenceSystem: ReferenceType;
  prescMovementAssembly: PrescribedMovementAssembly[];
  anForcesReferenceSystem: ReferenceType;
  prescMovAssemblyNodalForces: PrescribedMovementAssembly[];
  loads: Loads[];

  constructor() {}
}
